import { render, staticRenderFns } from "./AssignPackage.vue?vue&type=template&id=6e770457&"
import script from "./AssignPackage.vue?vue&type=script&lang=js&"
export * from "./AssignPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports